/* eslint-disable class-methods-use-this */
/* eslint-disable no-useless-constructor */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { DocumentCollection } from '../../collection';
import APIManager from '../../manager/APIManager';

/**
 * 保存ダイアログ
 */
export default class DocumentListDialog extends Dialog {
  documentList: DocumentCollection[] = [];

  guid: string = '';

  /**
   * コンストラクタ
   */
  constructor(draggable) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    // ダイアログのコンテンツ生成
    const id: string = 'documentListDialog';
    // タイトル
    let title: string = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '添付書類一覧'; break;
      default: title = 'Attached document list'; break;
    }
    let contents:string = '<div class="documentListMain">\n';
    contents += '<div class="documentListContainer">\n';
    contents += '<div class="documentListDisplay">\n';
    contents += this.documentListView();
    contents += '</div>\n';
    contents += '<div class="documentListImageWrap" id="documentListImageWrap">\n';
    contents += '<img src="assets/noImage.png"></img>\n';
    contents += '</div>\n';
    contents += '</div>\n';
    contents += '</div>\n';
    let footer: string = '<button id="btnAddDocument"><span class="jp">ドキュメント追加</span><span class="en">Add document</span></button>';
    footer += '<button id="btnClose"><span class="jp">閉じる</span><span class="en">Close</span></button>';
    this.createDialog(id, title, contents, footer);
    this.setEvents();
  }

  /**
   *イベントリスナー
   */
  private setEvents() {
    document.querySelectorAll('.imageViewDisplay').forEach((element:HTMLElement) => {
      element.addEventListener('click', (e: MouseEvent & TouchEvent) => {
        this.imageDisplayClick(e);
      });
    });
    document.querySelectorAll('.documentDownload').forEach((element:HTMLElement) => {
      element.addEventListener('click', (e: MouseEvent & TouchEvent) => {
        this.documentDownloadClick(e);
      });
    });
    document.getElementById('btnClose').onclick = (e: MouseEvent & TouchEvent) => {
      this.btnCloseHandler(e);
    };
    document.getElementById('btnAddDocument').onclick = (e: MouseEvent & TouchEvent) => {
      this.btnAddDocumentHandler(e);
    };
  }

  private documentListView(): string {
    let contents:string = '';
    if (Array.isArray(this.documentList)) {
      if (this.documentList.length > 0) {
        contents += '<ul>\n';
        this.documentList.forEach((document: DocumentCollection, index: number) => {
          contents += `<li class="documentListRow" data-index="${index + 1}">\n`;
          if (document.isPicture) {
            contents += `<span class="listView imageViewDisplay" data-url="${document.url}"  data-filename="${document.name}">${document.name}</span>\n`;
          } else {
            contents += `<span class="listView documentDownload" data-url="${document.url}"  data-filename="${document.name}">${document.name}</span>\n`;
          }
          contents += '</li>\n';
        });
        contents += '</ul>\n';
      }
    }
    return contents;
  }

  private hasPictureListener:boolean = false;
  private currentImageSource:string;

  /**
   * 画像ビューアクション
   * @param e
   */
  private imageDisplayClick = (e: MouseEvent & TouchEvent) => {
    const self:DocumentListDialog = this;
    const showPictureDialog = () =>{
      marietta.webcad.WebCADGlobal.showDialog( marietta.webcad.view.dialog.PlanPictureDialog, true, true, true, false, {image:self.currentImageSource}  );
    }

    const url = (<HTMLElement>e.currentTarget).getAttribute('data-url');
    if (url) {
      const apiManager = new APIManager(url, 'GET', 'BLOB');
      apiManager.action().then((res: any) => {
        if (res.status === 200) {
          const blob: Blob = res.data;
          const type = blob.type.split('/')[1];
          const _extension = type;
          if (_extension) {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = function () {
              const base64data = reader.result;
              const imageSRc = `data:image/${_extension};${base64data}`;
              const html = `<img src='${imageSRc}'></img>`;
              document.getElementById('documentListImageWrap').innerHTML = html;

              self.currentImageSource = imageSRc;
              if( !self.hasPictureListener ){
                document.getElementById('documentListImageWrap').addEventListener( 'click', showPictureDialog );
                document.getElementById('documentListImageWrap').style.cursor = 'pointer';
                self.hasPictureListener = true;
              }
              document.querySelectorAll('.documentListRow .listView').forEach((element:HTMLElement) => {
                element.classList.remove('selected');
              });


              (<HTMLElement>e.target).classList.add('selected');
            };
          } else {
            marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_ATTACHED_IMAGE_VIEW'));
          }
        } else {
          marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_ATTACHED_IMAGE_VIEW'));
        }
      });
    } else {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NO_ATTACHED_IMAGE'));
    }
  }

  /**
   * ドキュメントダウンロードアクション
   * @param e
   */
  private documentDownloadClick = (e: MouseEvent & TouchEvent) => {
    const url = (<HTMLElement>e.currentTarget).getAttribute('data-url');
    if (url) {
      const apiManager = new APIManager(url, 'GET', 'BLOB');
      apiManager.action().then((res: any) => {
        if (res.status === 200) {
          const blob: Blob = res.data;
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          const name = this.getFileName('document');
          const type = blob.type.split('/')[1];
          const _extension = type;
          if (_extension) {
            link.download = `${name}.${_extension}`;
            link.click();
          } else {
            marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_ATTACHED_DOCUMENT_DOWNLOAD'));
          }
        } else if (res.status === 404) {
          marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_ATTACHED_DOCUMENT_DOWNLOAD'));
        }
      });
    } else {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NO_ATTACHED_DOCUMENT'));
    }
  }

  /**
   * ダウンロードファイル名を取得する
   * @param name
   * @returns
   */
  getFileName(name: string): string {
    const datetime = new Date();
    const date = new Date().toISOString().slice(0, 10).split('-')
      .map((d) => parseInt(d, 10))
      .join('');
    let filename: string = '';
    if (name) {
      filename = `${name}_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}`;
    } else {
      filename = `${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}`;
    }
    return filename;
  }

  /**
  * 閉じるボタンが押された
  */
  close = () => {
    this.closeEvent();
  }

  /**
   * 閉じるボタンイベント
   * @return void
   * @param e => mouse event
  */
  private btnCloseHandler = (e: MouseEvent & TouchEvent) => {
    e.preventDefault();
    this.close();
  }

  /**
   * ドキュメント追加ボタンイベント
   * @return void
   * @param e => mouse event
  */
  private btnAddDocumentHandler = (e: MouseEvent & TouchEvent) => {
    const element = document.querySelector(`button.btnDocumentsEdit[data-guid="${this.guid}"]`);
    if (element) {
      (<HTMLElement>element).click();
    }
    this.close();
  }
}
